//@flow
import {useState, useEffect} from 'react';

import {generateQR} from '.';

export function useQrCode(text?: string) {
  const [loading, setLoading] = useState(false);
  const [qrDataUrl, setQrDataUrl] = useState<string | null>(null);

  const encodeQr = (text: string) => {
    setLoading(true);
    generateQR(text)
      .then(dataUrl => {
        setQrDataUrl(dataUrl);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    if (!text) return;
    encodeQr(text);
  }, [text]);

  return {
    isGenerating: loading,
    qrDataUrl,
    encodeQr,
  };
}
